const metrics = [
    {
        name: "work-time",
        value: 7.52,
        oldValue: 5.09,
    },
    {
        name: "work-speed",
        value: 6.23,
        oldValue: 3.78,
    },
    {
        name: "work-process",
        value: 5.37,
        oldValue: 6.31,
    },
];

const overall = {
    value: 7.29,
    oldValue: 6.69,
};

const getWorkMiniIndexes = () => {
    return {
        metrics,
        overall,
    };
};

export default getWorkMiniIndexes;
